import styled from 'styled-components';

import Button from '@components/Button/next';
import Drawer, { DrawerTitle } from '@components/Drawer/next';

export const Container = styled.div`
  padding: 0 15px;
  background: ${({ theme }) => theme.palette.white};
  max-height: 78px;
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Location Start's Here
// ==================================================
// ==================================================

export const StyledListingLocationDrawer = styled(Drawer)`
  ${DrawerTitle} {
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.black};
    white-space: nowrap;
  }

  .select-content {
    min-width: 100%;
  }

  .select-text-content {
    width: 100%;
  }
  .select-text {
    width: 100%;
  }

  .select-input {
    width: 100%;
  }
` as any;

export const ResponsiveLocationDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ResponsiveListingSearchLocationSelect = styled.div`
  height: 63px;
  margin: 10px 0 0 0;
  border-bottom: 1px solid rgba(75, 75, 75, 0.5);
  padding: 0 6px;

  & div {
    padding: 0;
  }
`;

export const ResponsiveLocationListItems = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10000;
`;

export const ResponsiveLocationItems = styled.div`
  padding: 0 15px;
  width: 100%;
  height: fit-content;
  height: 100%;
  overflow: auto;
  z-index: 999999999;
  transition: all 0.5s;
  flex: 1;
  margin-top: 10px;
`;

export const ListItemsWrappedByHeader = styled.div`
  max-height: 300px;
  height: fit-content;
  padding: 20px 0;
`;

export const ResponsiveLocationListItem = styled.div`
  display: flex;
  align-items: center;
`;
export const ResponsiveLocationListItemContent = styled(Button)`
  border: none;
  padding: 25px 0;
  background-color: ${({ theme }) => theme.palette.white};
  transition: all 0.4s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  flex: 1;
  position: relative;
  box-shadow: none;
  width: calc(100% - 40px);
  &:hover,
  &:focus {
    background: none;
  }
`;

export const ResponsiveLocationListItemIcon = styled.div`
  margin-right: 18px;
`;

export const ResponsiveLocationListItemText = styled.span`
  display: table-cell;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

// ==================================================
// ==================================================
// Style The Responsive Search By Location End's Here
// ==================================================
// ==================================================

export const ResponsiveSearchDrawerButtonWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 15px;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
  background-color: ${({ theme }) => theme.palette.white};
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  width: 100%;
  display: block;
  font-weight: bold;
  font-size: 16px;
`;

export const Wrapper = styled.div`
  margin-left: -10px;
`;
